<template>
  <div style="padding: 0 15px;">
    <h2 class="refund_detail_h2">退款套餐信息</h2>
    <div class="refund_detail_item">签约单号: {{ refundInfo.order_id }}</div>
    <div class="refund_detail_item">订单金额: ¥{{ refundInfo.total_price/100 }}</div>
    <div class="refund_detail_item">套餐天数: {{ refundInfo.effective_day }}</div>
    <div class="refund_detail_item">已上天数: {{ refundInfo.effective_day - (refundInfo.value_info && refundInfo.value_info.refund_days) }}</div>
    <div class="refund_detail_item">发票信息: {{ refundInfo.invoice_status }}</div>
    <div class="refund_detail_item" style="color:red">退款金额: ¥{{ refundInfo.amount/100 }}</div>
    <h2 class="refund_detail_h2">退款原因</h2>
    <div class="refund_detail_item">{{ refundInfo.extra && refundInfo.extra.refundReason }}</div>
    <h2 class="refund_detail_h2">挽单信息</h2>
    <div v-if="refundInfo.extra && refundInfo.extra.refundProcess" class="refund_detail_item">{{ refundInfo.extra && refundInfo.extra.refundProcess }}</div>
    <div v-if="refundInfo.status == 100" class="refund_detail_item">
      <el-input v-model="postForm.refund_process" placeholder="输入挽单信息" type="textarea" :rows="5" />
    </div>
    <el-row v-if="refundInfo.status == 100" type="flex" :gutter="20">
      <el-col :span="9"> <el-input v-model="postForm.remark" clearable placeholder="请输入失败原因" /></el-col>
      <el-col :span="5"> <el-button type="info" @click="fnAuditLearningManage('fail')">审核失败</el-button></el-col>
      <el-col :span="4"> <el-button type="primary" @click="fnAuditLearningManage('success')">审核成功</el-button></el-col>
    </el-row>
    <el-row v-if="refundInfo.status == 105" type="flex" :gutter="20">
      <el-col :span="7"> <el-input v-model="postForm.remark" clearable placeholder="请输入失败原因" /></el-col>
      <el-col :span="5"> <el-button type="info" @click="fnAuditCompany('fail')">审核失败</el-button></el-col>
      <el-col :span="7"> <el-input v-model="postForm.responsible_name" clearable placeholder="责任人" /></el-col>
      <el-col :span="5"> <el-button type="primary" @click="fnAuditCompany('success')">审核成功</el-button></el-col>
    </el-row>
  </div>
</template>

<script>

// import Tool from '@/assets/js/tool.js'

const defaultPostFrom = {
  refund_id: '',
  remark: '',
  audit_status: '',
  responsible_name: '',
  refund_process: ''
}

export default {
  name: 'DeviceStoreMange',
  components: {

  },
  props: {
    refund: {
      type: [String, Number],
      required: false,
      default: ''
    },
    edit: {
      type: [String, Boolean],
      required: false,
      default: true
    }
  },
  data() {
    return {
      refundInfo: { value_info: {}},
      postForm: Object.assign({}, defaultPostFrom)
    }
  },
  watch: {

  },
  created() {
    this.fnGetRefundDetail()
  },
  methods: {
    fnGetRefundDetail: function() {
      this.$http.tyyRefundRow({ refund_id: this.refund }).then(res => {
        this.refundInfo = res.data
        this.postForm.refund_id = res.data.refund_id
        // 不允许编辑将状态设置0
        if (!this.edit) {
          this.refundInfo.status = 0
        }
      })
    },
    fnAuditLearningManage: function(status) {
      this.postForm.audit_status = status
      if (status == 'fail' && !this.postForm.remark) {
        this.$message.error('请填写审核失败原因')
        return
      }
      if (status == 'success' && this.refundInfo.status == '100' && !this.postForm.refund_process) {
        this.$message.error('请填写挽单原因')
        return
      }
      this.$http.tyyPresidentOrLeaderAudit(this.postForm).then(res => {
        this.$message.success('操作成功')
        this.$emit('auditsuccess', {})
      })
    },
    fnAuditCompany: function(status) {
      this.postForm.audit_status = status
      if (status == 'fail' && !this.postForm.remark) {
        this.$message.error('请填写审核失败原因')
        return
      }
      this.$http.tyyGeneralAudit(this.postForm).then(res => {
        this.$message.success('操作成功')
        this.$emit('auditsuccess', {})
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer{
    text-align: right;
}
.refund_detail_h2 {
    margin-bottom: 10px;
}
.refund_detail_item {
    margin-bottom: 10px;
}

</style>
